'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRuleEditPage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/$id/')({
  component: AccessRuleEditRoute
});
function AccessRuleEditRoute() {
  const {
    id
  } = Route.useParams();
  return <AccessRuleEditPage paths={SETTINGS_AUTH_POLICY_PATHS} id={id} />;
}